import { apiCall } from './gqlClient';

const GETCUSTOMERS_QUERY = `
  query getCustomers($notArchived: Boolean, $active: Boolean, $isApproved: Boolean) {
    getCustomers(notArchived: $notArchived, active: $active, isApproved: $isApproved)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
      ...fragments
    }
  }`;

export const getCustomersApiCall = async ({notArchived, active, isApproved}, fragments = null) => apiCall({ query: GETCUSTOMERS_QUERY, variables: {notArchived, active, isApproved}, fragments });

const GETPROVIDERBLACKLISTEDUSERS_QUERY = `
  query getProviderBlacklistedUsers {
    getProviderBlacklistedUsers
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
      ...fragments
    }
  }`;

export const getProviderBlacklistedUsersApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERBLACKLISTEDUSERS_QUERY, variables: {}, fragments });

const GETUSERPROFILEINFOFORCOPY_QUERY = `
  query getUserProfileInfoForCopy($id: Int!) {
    getUserProfileInfoForCopy(id: $id)
    {
      codiceFiscale
			piva
			sdi
			firstname
			lastname
			address
			birthday
			phone
			country
			email
			gender
      ...fragments
    }
  }`;

export const getUserProfileInfoForCopyApiCall = async ({id}, fragments = null) => apiCall({ query: GETUSERPROFILEINFOFORCOPY_QUERY, variables: {id}, fragments });

const GETINACTIVECUSTOMERS_QUERY = `
  query getInactiveCustomers {
    getInactiveCustomers
    {
      id
			customerId
			name
			email
			firstname
			lastname
      ...fragments
    }
  }`;

export const getInactiveCustomersApiCall = async (fragments = null) => apiCall({ query: GETINACTIVECUSTOMERS_QUERY, variables: {}, fragments });

const GETUSERSASSIGNEDTOPRODUCT_QUERY = `
  query getUsersAssignedToProduct($productId: String!) {
    getUsersAssignedToProduct(productId: $productId)
    {
      id
			customerId
			name
			email
			firstname
			lastname
      ...fragments
    }
  }`;

export const getUsersAssignedToProductApiCall = async ({productId}, fragments = null) => apiCall({ query: GETUSERSASSIGNEDTOPRODUCT_QUERY, variables: {productId}, fragments });

const GETARCHIVEDCUSTOMERS_QUERY = `
  query getArchivedCustomers {
    getArchivedCustomers
    {
      id
			userId
			email
			name
			archivedRole
			archivedDate
      ...fragments
    }
  }`;

export const getArchivedCustomersApiCall = async (fragments = null) => apiCall({ query: GETARCHIVEDCUSTOMERS_QUERY, variables: {}, fragments });

const GETCUSTOMERINVITATIONFLOW_QUERY = `
  query getCustomerInvitationFlow($customerFlowId: String!) {
    getCustomerInvitationFlow(customerFlowId: $customerFlowId)
  }`;

export const getCustomerInvitationFlowApiCall = async ({customerFlowId}, ) => apiCall({ query: GETCUSTOMERINVITATIONFLOW_QUERY, variables: {customerFlowId}});

const GETCUSTOMERPERSONALINFORMATION_QUERY = `
  query getCustomerPersonalInformation($customerId: Int!, $userId: Int!) {
    getCustomerPersonalInformation(customerId: $customerId, userId: $userId)
  }`;

export const getCustomerPersonalInformationApiCall = async ({customerId, userId}, ) => apiCall({ query: GETCUSTOMERPERSONALINFORMATION_QUERY, variables: {customerId, userId}});

const GETCUSTOMERFLOWINFORMATION_QUERY = `
  query getCustomerFlowInformation($customerId: Int!, $customerFlowId: String!) {
    getCustomerFlowInformation(customerId: $customerId, customerFlowId: $customerFlowId)
  }`;

export const getCustomerFlowInformationApiCall = async ({customerId, customerFlowId}, ) => apiCall({ query: GETCUSTOMERFLOWINFORMATION_QUERY, variables: {customerId, customerFlowId}});

const CREATECUSTOMERWALKIN_QUERY = `
  mutation createCustomerWalkIn($name: String!, $note: String, $email: String, $phone: String, $svcGroupId: String, $lastname: String) {
    createCustomerWalkIn(name: $name, note: $note, email: $email, phone: $phone, svcGroupId: $svcGroupId, lastname: $lastname)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
      ...fragments
    }
  }`;

export const createCustomerWalkInApiCall = async ({name, note, email, phone, svcGroupId, lastname}, fragments = null) => apiCall({ query: CREATECUSTOMERWALKIN_QUERY, variables: {name, note, email, phone, svcGroupId, lastname}, fragments });

const CREATECUSTOMER_QUERY = `
  mutation createCustomer($request: CustomerInput!) {
    createCustomer(request: $request)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
      ...fragments
    }
  }`;

export const createCustomerApiCall = async ({request}, fragments = null) => apiCall({ query: CREATECUSTOMER_QUERY, variables: {request}, fragments });

const CONVERTWALKININTOCUSTOMER_QUERY = `
  mutation convertWalkinIntoCustomer($id: Int!, $name: String!, $email: String!) {
    convertWalkinIntoCustomer(id: $id, name: $name, email: $email)
    {
      id
			resourceId
			ownerId
			ownerIds
			name
			firstname
			lastname
			fullname
			gender
			birthday
			address
			city
			postcode
			country
			tags
			url
			facebook
			phone
			email
			role
			code
			codeExpiration
			active
			image
			status
			providerId
			providersIds
			userLanguage
			blacklisted
			blockContent
			describedName
			note
			codiceFiscale
			piva
			sdi
			created
			ordersNumber
			customerId
			svcGroupId
			groupColor
			completedOnboarding
			timezone
      ...fragments
    }
  }`;

export const convertWalkinIntoCustomerApiCall = async ({id, name, email}, fragments = null) => apiCall({ query: CONVERTWALKININTOCUSTOMER_QUERY, variables: {id, name, email}, fragments });

const CREATEVISITATOREFROMCSV_QUERY = `
  mutation createVisitatoreFromCSV($customers: JSON!, $svcGroupId: String) {
    createVisitatoreFromCSV(customers: $customers, svcGroupId: $svcGroupId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createVisitatoreFromCSVApiCall = async ({customers, svcGroupId}, fragments = null) => apiCall({ query: CREATEVISITATOREFROMCSV_QUERY, variables: {customers, svcGroupId}, fragments });

const CREATEUSERSFROMCSV_QUERY = `
  mutation createUsersFromCSV($customers: JSON!, $svcGroupId: String) {
    createUsersFromCSV(customers: $customers, svcGroupId: $svcGroupId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createUsersFromCSVApiCall = async ({customers, svcGroupId}, fragments = null) => apiCall({ query: CREATEUSERSFROMCSV_QUERY, variables: {customers, svcGroupId}, fragments });

const TOGGLEUSERBLACKLISTSTATUS_QUERY = `
  mutation toggleUserBlacklistStatus($userId: Int!, $blacklisted: Boolean!) {
    toggleUserBlacklistStatus(userId: $userId, blacklisted: $blacklisted)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const toggleUserBlacklistStatusApiCall = async ({userId, blacklisted}, fragments = null) => apiCall({ query: TOGGLEUSERBLACKLISTSTATUS_QUERY, variables: {userId, blacklisted}, fragments });

const BLOCKUSER_QUERY = `
  mutation blockUser($userId: Int!, $blockContent: Boolean!) {
    blockUser(userId: $userId, blockContent: $blockContent)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const blockUserApiCall = async ({userId, blockContent}, fragments = null) => apiCall({ query: BLOCKUSER_QUERY, variables: {userId, blockContent}, fragments });

const UNBLOCKUSER_QUERY = `
  mutation unblockUser($userId: Int!) {
    unblockUser(userId: $userId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const unblockUserApiCall = async ({userId}, fragments = null) => apiCall({ query: UNBLOCKUSER_QUERY, variables: {userId}, fragments });

const TOGGLEBLOCKEDUSERCONTENT_QUERY = `
  mutation toggleBlockedUserContent($userId: Int!, $blockContent: Boolean!) {
    toggleBlockedUserContent(userId: $userId, blockContent: $blockContent)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const toggleBlockedUserContentApiCall = async ({userId, blockContent}, fragments = null) => apiCall({ query: TOGGLEBLOCKEDUSERCONTENT_QUERY, variables: {userId, blockContent}, fragments });

const UPDATECUSTOMERGROUP_QUERY = `
  mutation updateCustomerGroup($id: Int!, $svcGroupId: String) {
    updateCustomerGroup(id: $id, svcGroupId: $svcGroupId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateCustomerGroupApiCall = async ({id, svcGroupId}, fragments = null) => apiCall({ query: UPDATECUSTOMERGROUP_QUERY, variables: {id, svcGroupId}, fragments });

const UPDATECUSTOMER_QUERY = `
  mutation updateCustomer($customer: NormalCustomerUpdateInput!) {
    updateCustomer(customer: $customer)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateCustomerApiCall = async ({customer}, fragments = null) => apiCall({ query: UPDATECUSTOMER_QUERY, variables: {customer}, fragments });

const UPDATEWALKINCUSTOMER_QUERY = `
  mutation updateWalkInCustomer($walkinCustomer: WalkinCustomerUpdateInput!) {
    updateWalkInCustomer(walkinCustomer: $walkinCustomer)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateWalkInCustomerApiCall = async ({walkinCustomer}, fragments = null) => apiCall({ query: UPDATEWALKINCUSTOMER_QUERY, variables: {walkinCustomer}, fragments });

const COPYDATAFROMPROFILE_QUERY = `
  mutation copyDataFromProfile($id: Int!) {
    copyDataFromProfile(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const copyDataFromProfileApiCall = async ({id}, fragments = null) => apiCall({ query: COPYDATAFROMPROFILE_QUERY, variables: {id}, fragments });

const REMOVECUSTOMER_QUERY = `
  mutation removeCustomer($id: Int!) {
    removeCustomer(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const removeCustomerApiCall = async ({id}, fragments = null) => apiCall({ query: REMOVECUSTOMER_QUERY, variables: {id}, fragments });

const RESTORECUSTOMER_QUERY = `
  mutation restoreCustomer($id: Int!) {
    restoreCustomer(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const restoreCustomerApiCall = async ({id}, fragments = null) => apiCall({ query: RESTORECUSTOMER_QUERY, variables: {id}, fragments });

const REINVITEINACTIVECUSTOMERS_QUERY = `
  mutation reinviteInactiveCustomers($inactiveCustomers: [InactiveUserInput]!, $flowId: String) {
    reinviteInactiveCustomers(inactiveCustomers: $inactiveCustomers, flowId: $flowId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const reinviteInactiveCustomersApiCall = async ({inactiveCustomers, flowId}, fragments = null) => apiCall({ query: REINVITEINACTIVECUSTOMERS_QUERY, variables: {inactiveCustomers, flowId}, fragments });

const COMPLETECUSTOMERINVITATIONFLOW_QUERY = `
  mutation completeCustomerInvitationFlow($customerFlowId: String!) {
    completeCustomerInvitationFlow(customerFlowId: $customerFlowId)
  }`;

export const completeCustomerInvitationFlowApiCall = async ({customerFlowId}, ) => apiCall({ query: COMPLETECUSTOMERINVITATIONFLOW_QUERY, variables: {customerFlowId}});
